import { fromJS } from 'immutable';
import * as constants from './constants';
import R from 'ramda';

const initialState = fromJS({
  allContractPartners: [],
  bccSelf: false,
  contractRequest: {},
  contractsSent: false,
  drafts: [],
  loadedLocations: false,
  loadedTemplates: false,
  loadingLocations: false,
  loadingTemplates: false,
  locationId: null,
  locations: [],
  message: '',
  processedPartners: [],
  processingPartners: false,
  productIdNameMap: {},
  sendingContracts: false,
  sendTemplateOrGroup: '',
  stepIndex: 0,
  subject: '',
  templateGroups: [],
  templateGroupSelected: {},
  templates: [],
  templateSelected: {},
});

const supplierWizard = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'UPDATE_CONTRACTING_DASHBOARD_PROP':
      if (payload.sendToPFBuyers) return state.set('startDate', payload.startDate).set('endDate', payload.endDate);
      return state;
    case constants.GET_CONTRACT_REQUEST_INFO:
      return state.setIn(['contractRequest', 'contractId'], payload);
    case `${constants.GET_CONTRACT_REQUEST_INFO}_SUCCESS`:
      return state.set('contractRequest', fromJS(payload))
        .setIn(['contractRequest', 'contentLoaded'], true)
        .set('startDate', payload.startDate)
        .set('endDate', payload.endDate);
    case '[supplier-wizard]GET_RESPONDED_CONTRACT_LIST_SUCCESS':
      return state.setIn(['contractRequest', 'respondedContractList'], fromJS(payload.list));
    case constants.SENDING_CONTRACTS:
      return state.set('sendingContracts', !state.get('sendingContracts'));
    case constants.CONTRACTS_CREATED:
      return state.set('sendingContracts', false).set('contractsSent', true);
    case constants.UPDATE_PROPS:
      return state.merge(fromJS(payload));
    case constants.LOADING_TEMPLATES:
      return state.set('loadingTemplates', !state.get('loadingTemplates'));
    case constants.LOCATIONS_LOADED:
      const filteredLocations = (payload.locations || []);
      return state.set('locations', fromJS(filteredLocations))
        .set('loadingLocations', false)
        .set('loadedLocations', true)
        .set('singleLoc', filteredLocations.length === 1)
        .set('locationId', filteredLocations.length === 1 ? R.path([0, 'id'], filteredLocations) : undefined);
    case constants.PROCESSING_PARTNERS:
      return state.set('processingPartners', !state.get('processingPartners'));
    case constants.PARTNERS_PROCESSED:
      return state.set('processedPartners', fromJS(payload.processedPartners)).set('stepIndex', 2);
    case constants.TEMPLATES_LOADED:
      return state.merge(fromJS(payload)).set('loadedTemplates', true);
    case constants.CLEAR_STORE:
      return initialState.merge({
        templateGroups: state.get('templateGroups'),
        locations: state.get('locations'),
        templates: state.get('templates'),
      });
    case constants.RESET_TEMPLATE_SELECTION:
      return state.set('locationId', state.get('singleLoc') ? state.get('locationId') : null)
        .set('templateGroupSelected', fromJS({}))
        .set('templateSelected', fromJS({}));
    case constants.RESET_LOCATION_SELECTION:
      return state.set('locationId', state.get('singleLoc') ? state.get('locationId') : null);
    default:
      return state;
  }
};

export default supplierWizard;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/supplier-wizard/reducer.js